const visualElementStore = /* @__PURE__ */ new WeakMap();
export {
  visualElementStore
};
//# sourceMappingURL=store.js.map
